import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchDeviceGradeConditionUrlOptions } from '../types';

/**
 * This is to track the DEVICE ITEM CONDITION in react query cache.
 */
export const DEVICE_ITEM_CONDITION_QUERY_KEY =
  'device-item-condition-query-key';

/**
 * This hook fetches the Device Item condition details using appraisalCode.
 */
export const useDeviceItemConditionQuery = (
  queryParams: IFetchDeviceGradeConditionUrlOptions
) => {
  const { appraisalCode } = queryParams;

  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [DEVICE_ITEM_CONDITION_QUERY_KEY, appraisalCode],
      enabled: !!appraisalCode,
      queryFn: () =>
        CUSTOMER_SERVICE_API.fetchDeviceItemConditions(queryParams),
    });

  return {
    data,
    error,
    isPending,
    isFetching,
    isError,
    refetch,
  };
};
